import styled from 'styled-components';
import { NoResult } from 'ui/illustrations';
import { spacing, heading4, body2, colors } from 'ui/theme';
import { useCampaignContext } from 'modules/campaigns/editor/context';
import { getIsEligibilityCampaign } from 'modules/campaigns/editor/components/utils';

export const NO_RESULTS_TEST_ID = 'no-results';

const NoResultWrapper = styled.div`
  padding: ${spacing.plusHalf};
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
`;

const NoResultHeader = styled.div`
  ${heading4}
`;

const NoResultBody = styled.div`
  ${body2}
  color: ${colors.secondaryText};
  text-align: center;
`;

export const NoResults = () => {
  const { campaign } = useCampaignContext();
  const isEligibility = getIsEligibilityCampaign(campaign.campaignTypeDefinition);

  return (
    <NoResultWrapper data-test={NO_RESULTS_TEST_ID}>
      <NoResult />
      <NoResultHeader>{isEligibility ? "Who's eligible?" : 'No contacts yet'}</NoResultHeader>
      <NoResultBody>
        {isEligibility
          ? 'To define an audience for your campaign, select a dynamic list.'
          : 'Broadcast campaigns require a send list to continue. Choose who you’d like to send or suppress this campaign.'}
      </NoResultBody>
    </NoResultWrapper>
  );
};
